export type ScoreSeverity = 'critical' | 'high' | 'medium' | 'low';

export function scoreSeverity(score: number): ScoreSeverity {
  if (score >= 8) return 'critical';
  if (score >= 6) return 'high';
  if (score >= 4) return 'medium';
  return 'low';
}

export function bandColorVar(score: number): string {
  switch (scoreSeverity(score)) {
    case 'critical':
      return 'var(--gr-red)';
    case 'high':
      return 'var(--gr-orange)';
    case 'medium':
      return 'var(--gr-light-orange)';
    case 'low':
      return 'var(--gr-green)';
  }
}
